const SettingsState = {
  settings: []
};

export default SettingsState;
